import { privateFetch } from "api/privateFetch";

/**
 * Logout
 * @param {number} id User ID
 * @returns {Promise<void>} Response
 */
const clearCookies = async (id) => {
  const { data } = await privateFetch.post(`/logout/${id}`);
  return data;
};

export default clearCookies;
